<template>
  <div class="sp-template plate-template order-plate-template">
    <div class="h-title">新建订单</div>
    <el-card class="box-card">
      <div class="plate-content">
        <el-form :model="orderForm.deliveryDetail" size="small" :rules="orderFormRule" ref="orderForm1" 
          class="new-order__form" :label-width="formLabelWidth">
            <el-form-item label="取件方式">
              <el-tooltip effect="dark" content="我们将在1-2天内上门取件，为收货方便，请提前准备好货物！当运费小于500元时，按货物重量收取费用" placement="top-start">
                <el-radio v-model="orderForm.deliveryDetail.deliveryType" @change="changedeliveryType" label="PICK_UP_FROM_CUSTOMER">预约上门取件</el-radio>
              </el-tooltip>
              <el-tooltip effect="dark" content="请根据您的货物地址，选择距离货物最近的收货仓库" placement="top-start">
                <el-radio v-model="orderForm.deliveryDetail.deliveryType" @change="changedeliveryType" label="DELIVERY">送货至仓库</el-radio>
              </el-tooltip>
              <el-tooltip effect="dark" content="请根据您的货物地址，选择距离货物最近的收货仓库" placement="top-start">
                <el-radio v-model="orderForm.deliveryDetail.deliveryType" @change="changedeliveryType" label="DELIVERY_BY_EXPRESS">快递至仓库</el-radio>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="取件地址" v-show="orderForm.deliveryDetail.deliveryType == 'PICK_UP_FROM_CUSTOMER'">
              <div class="pickup-content">
                <p class="pickup-button">
                  <el-button size="mini" type="text" @click="addressFormVisible = true">编辑地址</el-button>
                </p>
                <ul class="pickup-address">
                  <li>{{orderForm.deliveryDetail.province}}</li>
                  <li>{{orderForm.deliveryDetail.city}}</li>
                  <li>{{orderForm.deliveryDetail.addressFirst}}</li>
                  <li>{{orderForm.deliveryDetail.contractName}}</li>
                  <li>{{orderForm.deliveryDetail.phone}}</li>
                </ul>
              </div>
            </el-form-item>
            <el-form-item label="交货仓库地址">
              <div class="pickup-content">
                <el-select v-model="warehouseId" filterable v-if="flag" placeholder="请选择" @change="selectWarehouse">
                  <el-option v-for="item in warehouse" :key="item.id" :label="item.title" :value="item.id"></el-option>
                </el-select>
                <ul class="pickup-address">
                  <li>{{userCarry[0].title}}</li>
                  <li>{{userCarry[0].address}}</li>
                  <li>{{userCarry[0].name}}</li>
                  <li>{{userCarry[0].phone}}</li>
                </ul>
              </div>
            </el-form-item>
            <el-form-item :label="orderForm.deliveryDetail.deliveryType == 'PICK_UP_FROM_CUSTOMER' ? '预约取件时间' : '预计送达时间'" 
              v-show="orderForm.deliveryDetail.deliveryType!='DELIVERY_BY_EXPRESS'" prop="appointmentAt">
              <!-- <div class="pickup-time">
                <p>预计&nbsp;&nbsp;7月12日[周四]09:00-15:00&nbsp;&nbsp;取件</p> 
                <a href="#" @click.prevent="setupPickupTime">修改</a>
              </div> -->
              <el-date-picker v-model="orderForm.deliveryDetail.appointmentAt" 
                :picker-options="appointmentAtOptions" 
                type="datetime" placeholder="选择日期" value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="快递公司" v-show="orderForm.deliveryDetail.deliveryType == 'DELIVERY_BY_EXPRESS'" prop="expressCompany">
              <el-input v-model="orderForm.deliveryDetail.expressCompany" auto-complete="off" placeholder="快递公司"></el-input>
            </el-form-item>
            <el-form-item label="快递单号" v-show="orderForm.deliveryDetail.deliveryType == 'DELIVERY_BY_EXPRESS'" prop="expressNumber">
              <el-input v-model="orderForm.deliveryDetail.expressNumber" auto-complete="off" placeholder="快递单号"></el-input>
            </el-form-item>
            
        </el-form>
      </div>
      <!-- 订单信息 -->
      <div class="plate-content">
        <div class="plate-content__title">
          <span class="title">订单信息</span>
          <el-checkbox style="margin-left:20px;" v-model="fbaChecked" @change="changeShippingAddressType">FBA地址</el-checkbox>
        </div>
        <el-form :model="orderForm.shippingDetail" size="small" :rules="orderFormRule2" ref="orderForm2" 
          class="new-order__form" :label-width="formLabelWidth">
            <div v-show="!fbaChecked">
              <div class="inline-flex">
                <div>
                  <el-form-item label="客户单号" prop="customerOrderNumber">
                    <el-input v-model="orderForm.customerRefnumber.customerOrderNumber" auto-complete="off" placeholder="由系统提供，可修改"></el-input>
                  </el-form-item>
                  <el-form-item label="联系人" prop="shippingContractName">
                    <el-input v-model="orderForm.shippingDetail.contractName" auto-complete="off" placeholder="如已存在联系人，则自动补充后面信息"></el-input>
                  </el-form-item>
                  <el-form-item label="国家" prop="shippingCountry">
                    <el-select v-model="shippingDetail.countryId" @change="queryProvince" filterable>
                      <el-option v-for="(country,i) in initialDataCountry" :key="i" :label="country.code" :value="country.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="城市" prop="shippingCity">
                    <el-select v-model="shippingDetail.cityId" @change="selectCity" filterable>
                      <el-option v-for="(city,i) in initialDataCity" :key="i" :label="city.nameEn" :value="city.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="详细地址1" prop="shippingAddressFirst">
                    <el-input type="textarea" v-model="orderForm.shippingDetail.addressFirst" auto-complete="off"></el-input>
                  </el-form-item>
                </div>
                <div>
                  <el-form-item label="公司名称">
                    <el-input v-model="orderForm.shippingDetail.companyName" auto-complete="off" placeholder="公司名称"></el-input>
                  </el-form-item>
                  <el-form-item label="联系电话" prop="shippingPhone">
                    <el-input v-model="orderForm.shippingDetail.phone" auto-complete="off" placeholder="联系电话"></el-input>
                  </el-form-item>
                  <el-form-item label="州/省" prop="shippingProvince">
                    <el-select v-model="shippingDetail.provinceId" @change="queryCity" filterable>
                      <el-option v-for="(province, i) in initialDataProvince" :key="i" :label="province.nameEn" :value="province.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="目的邮编" prop="zipcode">
                    <el-input v-model="orderForm.shippingDetail.zipcode" auto-complete="off" placeholder="目的邮编"></el-input>
                  </el-form-item>
                  <el-form-item label="详细地址2" prop="shippingAddressSecond">
                    <el-input type="textarea" v-model="orderForm.shippingDetail.addressSecond" auto-complete="off"></el-input>
                  </el-form-item>

                </div>
              </div>
            </div>
            <div class="inline-flex" v-show="fbaChecked">
              <div>
                <el-form-item label="客户单号">
                  <el-input v-model="orderForm.customerRefnumber.customerOrderNumber" auto-complete="off" placeholder="由系统提供，可修改"></el-input>
                </el-form-item>
                <el-form-item label="FBA仓码">
                  <el-select v-model="shippingDetail.fbaWarehouseCode" @change="changeFbaWarehouseCode" filterable>
                    <el-option v-for="(fba,i) in initialDataFbaAddress" :key="i" :label="fba.warehouseCode" :value="fba.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="省/州" prop="shippingProvince2">
                  <el-input v-model="orderForm.shippingDetail.province" auto-complete="off" placeholder="根据仓码自动匹配"></el-input>
                </el-form-item>
                <el-form-item label="目的邮编" prop="zipcode">
                  <el-input v-model="orderForm.shippingDetail.zipcode" auto-complete="off" placeholder="根据仓码自动匹配，可修改" v-on:input="queryFbaByAdressOrZipcode"></el-input>
                </el-form-item>
                <el-form-item label="联系人" prop="shippingContractName">
                  <el-input v-model="orderForm.shippingDetail.contractName" auto-complete="off" placeholder="如已存在联系人，则自动补充后面信息"></el-input>
                </el-form-item>

                <el-form-item label="Amazon Reference ID" prop="amazonReferenceId">
                  <el-input v-model="orderForm.amazonReferenceId" auto-complete="off"></el-input>
                </el-form-item>
                
              </div>
              <div>
                <el-form-item label="FBA号">
                  <el-input v-model="orderForm.customerRefnumber.fbaNumber" auto-complete="off" placeholder="FBA号"></el-input>
                </el-form-item>
                <el-form-item label="目的国家" prop="shippingCountry">
                  <el-input v-model="orderForm.shippingDetail.country" auto-complete="off" placeholder="根据仓码自动匹配"></el-input>
                </el-form-item>
                <el-form-item label="目的城市" prop="shippingCity">
                  <el-input v-model="orderForm.shippingDetail.city" auto-complete="off" placeholder="根据仓码自动匹配，可修改"></el-input>
                </el-form-item>
                <el-form-item label="详细地址" prop="shippingAddressFirst">
                  <el-input type="textarea" :autosize="{ minRows: 1, maxRows: 4}" v-model="orderForm.shippingDetail.addressFirst" auto-complete="off" v-on:input="queryFbaByAdressOrZipcode"></el-input>
                </el-form-item>
                <el-form-item label="联系电话" prop="shippingPhone">
                  <el-input v-model="orderForm.shippingDetail.phone" auto-complete="off" placeholder="联系电话"></el-input>
                </el-form-item>
              </div>
            </div>
        </el-form>
      </div>
      <!-- 商品信息 -->
      <div class="plate-content">
        <div class="plate-content__title">
          <span class="title">装箱单信息</span>
          <el-checkbox style="margin-left:20px;" v-model="orderForm.generalTrade" :checked="false">一般贸易</el-checkbox>
          <el-checkbox style="margin-left:20px;" v-model="uploadCartonDetail">上传箱明细</el-checkbox>
          <el-checkbox style="margin-left:20px;" v-model="formData.usMeasure">以承运商测量数据为准</el-checkbox>
          <el-checkbox style="margin-left:20px;" v-model="orderForm.purchaseInsurance">是否购买保险</el-checkbox>
        </div>
        <el-form :model="orderForm.packingList" size="small" :rules="orderFormRule3" ref="orderForm3" class="new-order__form" :label-width="formLabelWidth">
          <el-form-item label="箱子规格" v-show="!formData.usMeasure && !uploadCartonDetail">
            <el-radio v-model="productForm.guigeRadio" label="1">全部相同</el-radio>
            <el-radio v-model="productForm.guigeRadio" label="2">不同</el-radio>
            <el-tooltip class="item" effect="dark" content="选全部相同则填写" placement="top">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </el-form-item>
          <div class="inline-flex">
            <div>
              <el-form-item label="货物类型" prop="goodsType">
                <el-select v-model="orderForm.packingList.goodsType">
                  <el-option v-for="(d,i) in goodsTypeList" :key="i" :label="d.name" :value="d.code"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="单箱尺寸" v-show="!formData.usMeasure && productForm.guigeRadio == 1 && !uploadCartonDetail">
                <div class="input-group">
                  <el-input v-model="guige.long" auto-complete="off" class="size" placeholder="长(cm)"></el-input>
                  <el-input v-model="guige.width" auto-complete="off" class="size" placeholder="宽(cm)"></el-input>
                  <el-input v-model="guige.height" auto-complete="off" class="size" placeholder="高(cm)"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="总体积(cbm)" v-show="!formData.usMeasure && !uploadCartonDetail">
                <el-input v-model="allTiji" auto-complete="off" placeholder="总体积" disabled></el-input>
                <el-tooltip class="item" effect="dark" content="仅供参考" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="货物箱数" prop="totalCarton" v-if="!uploadCartonDetail">
                <el-input v-model="orderForm.packingList.totalCarton" auto-complete="off" type="number" placeholder="货物箱数"></el-input>
              </el-form-item>
              <el-form-item label="单箱重量" v-show="!formData.usMeasure && productForm.guigeRadio == 1 && !uploadCartonDetail">
                <el-input v-model="guige.weight" auto-complete="off" placeholder="单箱货物重量(kg)"></el-input>
              </el-form-item>
              <el-form-item label="总重量(kg)" v-show="!formData.usMeasure && !uploadCartonDetail">
                <el-input v-model="allWeight" auto-complete="off" placeholder="总重量" disabled></el-input>
                <el-tooltip class="item" effect="dark" content="仅供参考" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </el-form-item>
            </div>
          </div>
          <el-form-item label="单箱SKU信息" v-show="productForm.guigeRadio == '1' && !uploadCartonDetail">
            <el-button type="text" @click="editCartonSkus">添加SKU</el-button>
          </el-form-item>
          <div class="carton-table__content single-sku" v-if="spList && spList.length > 0 && productForm.guigeRadio == '1' && !uploadCartonDetail">
            <el-table :data="spList" border style="width: 100%;">
              <el-table-column prop="sku" label="SKU"></el-table-column>
              <el-table-column prop="zhName" label="SKU中文名"></el-table-column>
              <el-table-column prop="number" label="数量"></el-table-column>
            </el-table>
          </div>

          <el-form-item label="箱子信息" v-show="productForm.guigeRadio == '2' && !uploadCartonDetail">
            <el-button type="text" @click="handleEditGuige">添加</el-button>
          </el-form-item>
          <div class="carton-table__content" v-if="guigeArr && guigeArr.length > 0 && productForm.guigeRadio == '2' && !uploadCartonDetail">
            <el-table :data="guigeArr" border style="width: 100%;">
              <el-table-column property="number" label="箱数"></el-table-column>
              <el-table-column property="long" label="长(cm)"></el-table-column>
              <el-table-column property="width" label="宽(cm)"></el-table-column>
              <el-table-column property="height" label="高(cm)"></el-table-column>
              <el-table-column property="weight" label="毛重(kg)"></el-table-column>
              <el-table-column label="SKU">
                <template slot-scope="scope">
                  <p v-for="(d,i) in scope.row.skus" :key="i">{{d.sku}}</p>
                </template>
              </el-table-column>
              <el-table-column label="数量">
                <template slot-scope="scope">
                  <p v-for="(d,i) in scope.row.skus" :key="i">{{d.number}}</p>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="220px">
                <template slot-scope="scope">
                  <el-button type="text" size="mini" @click="measureEditSkus(scope.$index)">添加/编辑SKU</el-button>
                  <el-button type="text" size="mini" @click="handleEditGuige( scope.row, scope.$index)">编辑</el-button>
                  <el-button type="text" size="mini" @click="handleDeleteGuige(scope.row, scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>

        
        <el-row v-show="uploadCartonDetail">
          <el-col :span="10">
            <el-form-item label="模板下载" :label-width="formLabelWidth">
              <a href="../../static/template/FBA-US-A-carton-sample.xlsx" class="download-template">美国空运模板</a>
              <a href="../../static/template/FBA-EU-A-carton-sample.xlsx" class="download-template">欧洲空运模板</a>
              <a href="../../static/template/FBA-S-carton-sample.xlsx" class="download-template">国际海运模板</a>
              <a href="../../static/template/new-railway-sample.xlsx" class="download-template">国际铁运模板</a> 
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-show="uploadCartonDetail">
          <el-col :span="10">
            <el-form-item label="文件上传" :label-width="formLabelWidth">
              <el-upload class="upload-demo" ref="uploadExcel" action="#" :limit="1" :on-exceed="exceedFile" :file-list="fileList" :on-change="fileChange" :auto-upload="false" accept=".xlsx">
                <el-button size="small" type="primary">选择文件</el-button>
                <div slot="tip" class="el-upload__tip">只能上传xlsx(Excel2007)文件，且不超过10M</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        
        
        
      </el-form>
      </div>
    </el-card>
    <div class="submit-buttons">
      <el-button @click="back">返 回</el-button>
      <el-button type="primary" @click="createOrderSubmit">确 定</el-button>
    </div>
    <!-- 预约取件时间弹层 -->
    <el-dialog title="取件时间" :visible.sync="timeDialogVisible">
      <div class="setupTimeTable">
        <dl class="th">
          <dt>时间段</dt>
          <dd class="date">
            <span v-for="date in computedDate" :key="date">
              date.day <br> date.week
            </span>
          </dd>
          <dd class="time">
            <span>09:00 - 11:00</span>
            <span>11:00 - 13:00</span>
            <span>13:00 - 15:00</span>
            <span>15:00 - 18:00</span>
            <span>18:00 - 20:00</span>
          </dd>
        </dl>
      </div>
    </el-dialog>
    <!-- 地图 -->
    <!-- <sp-amap id="sp-amap" v-if="initialDataWarehouseAddress.length != 0" width="100%" :class="{isOpen: isOpen}" :markers="initialDataWarehouseAddress" :isOpen="isOpen" @get-map-form="getMapForm" @get-geocoder="getGeocoder"></sp-amap> -->

    <!-- 上门取件弹层 -->
    <el-dialog title="编辑地址" :visible.sync="addressFormVisible" width="500px" class="fullwidth-form__dialog">
      <el-form size="small" :model="addressForm" label-width="80px" label-position="left">
        <el-form-item label="联系人">
          <el-input v-model.lazy="orderForm.deliveryDetail.contractName" placeholder="联系人"></el-input>
        </el-form-item>
        <el-form-item label="电话">
          <el-input v-model.lazy="orderForm.deliveryDetail.phone" placeholder="电话"></el-input>
        </el-form-item>
        <el-form-item label="州/省">
          <el-select v-model="deliveryDetail.provinceId" @change="queryCityOfChina" filterable>
            <el-option v-for="(province,i) in initialDataProvinceChina" :key="i" :label="province.nameCn" :value="province.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="市">
          <el-select v-model="orderForm.deliveryDetail.city" filterable>
            <el-option v-for="(city,i) in initialDataCityChina" :key="i" :label="city.nameCn" :value="city.nameCn"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="详细地址">
          <el-input v-model.lazy="orderForm.deliveryDetail.addressFirst" placeholder="详细地址"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="saveAddressOfDeliver">保 存</el-button>
      </div>
    </el-dialog>

    <!-- 非上门取件弹层 -->
    <!-- <el-dialog title="选取地址" :visible.sync="mapAddressFormVisible" class="gaide-map"> -->
    <!--高德地图-->
    <!-- <div ref="spAmap"></div>
      <el-form size="small" class="m-t-20">
        <el-form-item label="已选地址" label-width="70px">
          <b v-text="mapObj.title"></b>
          <span v-text="mapObj.address"></span>
        </el-form-item>
        <el-form-item label="联系人" label-width="70px">
          <span v-text="mapObj.name"></span>
        </el-form-item>
        <el-form-item label="联系电话" label-width="70px">
          <span v-text="mapObj.phone"></span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSmenSaveMap">保 存</el-button>
      </div>
    </el-dialog> -->

    <!-- 添加SKU -->
    <el-dialog class="sp-info-box" title="商品信息" :visible.sync="listTable" @close="skuEditClose" width="1000px">
      <div style="margin-bottom:10px; text-align: right;">
        <el-button size="small" @click="spHandleEdit">新增</el-button>
        <el-button size="small" @click="openHistoryListDialog">历史商品列表</el-button>
      </div>
      <el-table :data="spList" border style="width: 100%">
        <el-table-column prop="sku" label="SKU">
        </el-table-column>
        <el-table-column prop="zhName" label="中文品名"></el-table-column>
        <el-table-column prop="enName" label="英文品名"></el-table-column>
        <el-table-column prop="code" label="海关编码"></el-table-column>
        <el-table-column prop="money" label="申报价值"></el-table-column>
        <el-table-column label="数量">
          <template slot-scope="scope">
            <el-input size="small" v-model="scope.row.number"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="图片">
          <template slot-scope="scope">
            <img width="65" height="45" :src="scope.row.img">
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="spHandleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button type="text" @click="spHandleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="skuSaveSp">保 存</el-button>
      </div>
    </el-dialog>
    <!-- 添加箱子信息 -->
    <el-dialog :title="cartonDialogTitle" :visible.sync="addGuigeShow" width="400px" class="fullwidth-form__dialog">
      <el-form size="small" :model="addGuige" :rules="rulesAddGuige" ref="addGuige" label-width="80px" label-position="left" class="edit-address__from">
        <el-form-item v-show="false">
          <el-input v-model="addGuigeIndex" type="number" placeholder="index"></el-input>
        </el-form-item>
        <el-form-item label="长(CM)" class="must" prop="long" v-show="formData.usMeasure == false">
          <el-input v-model="addGuige.long" type="number" placeholder="长"></el-input>
        </el-form-item>
        <el-form-item label="宽(CM)" class="must" prop="width" v-show="formData.usMeasure == false">
          <el-input v-model="addGuige.width" type="number" placeholder="宽"></el-input>
        </el-form-item>
        <el-form-item label="高(CM)" class="must" prop="height" v-show="formData.usMeasure == false">
          <el-input v-model="addGuige.height" type="number" placeholder="高"></el-input>
        </el-form-item>
        <el-form-item label="毛重(KG)" class="must" prop="weight" v-show="formData.usMeasure == false">
          <el-input v-model="addGuige.weight" type="number" placeholder="毛重"></el-input>
        </el-form-item>
        <el-form-item label="箱数" class="must" prop="number">
          <el-input v-model="addGuige.number" type="number" placeholder="箱数"></el-input>
        </el-form-item>
        <el-form-item class="erro-info">
          <div class="erro-info-text" v-text="addGuigeErro"></div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click.native="handleSaveguige">保 存</el-button>
      </div>
    </el-dialog>

    <!-- 历史商品列表弹层 -->
    <el-dialog title="历史商品列表" :visible.sync="lishiTable" width="1000px">
      <el-form :inline="true" :model="conditions" class="demo-form-inline" size="small">
        <el-form-item>
          <el-input v-model="conditions.sku" placeholder="SKU/中文/英文品名" clearable style="width: 300px;"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="skuHistorySearch">搜索</el-button>
          <el-button type="success" @click="handleSaveSp">确 定</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="productData" border style="width: 100%;" ref="multipleTable" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="sku" label="SKU">
        </el-table-column>
        <el-table-column prop="zhName" label="中文品名"></el-table-column>
        <el-table-column prop="enName" label="英文品名"></el-table-column>
        <el-table-column prop="code" label="海关编码"></el-table-column>
        <el-table-column prop="money" label="申报价值"></el-table-column>
        <el-table-column prop="img" label="图片">
          <template slot-scope="scope">
            <img width="65" height="45" :src="scope.row.img">
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="prev, pager, next" :total="productHistoryList.total" :page-size="productHistoryList.pageSize" :current-page="productHistoryList.page" @current-change="currentPage" class="t-a-r m-t-20"></el-pagination>
    </el-dialog>
    <!-- 新增商品信息弹层 -->
    <el-dialog :title="editProductTitle" :visible.sync="addSPinfo" width="500px" class="fullwidth-form__dialog neworder-editsku__dialog">
      <el-form size="small" label-width="120px" label-position="left" :model="tmpProduct" :rules="rulesTmpProduct" ref="tmpProduct" class="add-product__form">
        <el-form-item label="SKU" prop="sku">
          <el-input placeholder="id" v-show="false" v-model="tmpProduct.id"></el-input>
          <el-input placeholder="SKU" v-model="tmpProduct.sku"></el-input>
        </el-form-item>
        <el-form-item label="中文品名" prop="zhName">
          <el-input placeholder="中文品名" v-model="tmpProduct.zhName"></el-input>
        </el-form-item>
        <el-form-item label="海关编码" prop="code">
          <el-input placeholder="海关编码" v-model="tmpProduct.code"></el-input>
        </el-form-item>
        <el-form-item label="英文品名" prop="enName">
          <el-input placeholder="英文品名" v-model="tmpProduct.enName"></el-input>
        </el-form-item>
        <!-- v-model.number -->
        <el-form-item label="单个净重" prop="weight">
          <el-input placeholder="单个净重" v-model="tmpProduct.weight"></el-input>
        </el-form-item>
        <el-form-item label="申报价值" prop="money">
          <div class="inline-flex">
            <el-select v-model="tmpProduct.currency" placeholder="请选择币种" size="small">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-input placeholder="申报价值" v-model="tmpProduct.money"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="商品图片" :label-width="formLabelWidth" prop="img">
          <el-upload action="#" :file-list="imgFile" list-type="picture-card" :limit="1" :on-change="imgChange" :auto-upload="false">
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible" append-to-body>
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="warning" size="small" v-show="nextAddProductButton" @click="handleAddSpContinue">继续添加</el-button>
        <el-button type="primary" size="small" @click="handleAddSp">完 成</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import formatDate from '../../../utils/formatDate.js'

function clone(obj) {
  if (!obj || typeof obj != "object") return obj;
  let _newObj = new Object();
  for (let key in obj) {
    _newObj[key] = clone(obj[key]);
  }
  return _newObj;
}

export default {
  components: {},
  data() {
    var checkNumber = (rule, value, callback) => {
      if (!this.formData.usMeasure) {
        if (!/^\d+.?\d{0,4}$/.test(value) || value <= 0) {
          callback(new Error("请输入大于0的整数或小数,小数最大精确4位"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    var checkInteger = (rule, value, callback) => {
      if (!/^\d+$/.test(value) || value <= 0) {
        callback(new Error("请输入大于0的整数"));
      } else {
        callback();
      }
    };
    var checkFormHeadDate = (rule, value, callback) => {
      if (
        this.orderForm.deliveryDetail.deliveryType == "DELIVERY" ||
        this.orderForm.deliveryDetail.deliveryType == "PICK_UP_FROM_CUSTOMER"
      ) {
        if (!value || value == "") {
          callback(new Error("日期不能为空，请选择日期"));
        } else {
          //地址校验
          if (
            this.orderForm.deliveryDetail.addressFirst == "" ||
            this.orderForm.deliveryDetail.city == "" ||
            this.orderForm.deliveryDetail.contractName == "" ||
            this.orderForm.deliveryDetail.phone == "" ||
            this.orderForm.deliveryDetail.province == ""
          ) {
            callback(new Error("请点击'编辑地址'按钮补全地址信息"));
          } else {
            callback();
          }
        }
      } else {
        callback();
      }
    };
    var checkFormHeadText = (rule, value, callback) => {
      if (this.orderForm.deliveryDetail.deliveryType == "DELIVERY_BY_EXPRESS") {
        if (!value || value == "") {
          callback(new Error("快递信息不能为空"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    var checkFormBodyTextorderNumber = (rule, value, callback) => {
      if (!this.fbaChecked) {
        if (this.orderForm.customerRefnumber.customerOrderNumber == "")
          callback(new Error("客户单号必填"));
        callback();
      } else {
        callback();
      }
    };
    var checkFormBodyTextaddressFirst = (rule, value, callback) => {
      if (this.orderForm.shippingDetail.addressFirst == "") {
        callback(new Error("详细地址必填"));
      } else {
        callback();
      }
    };

    var checkFormBodyTextcity = (rule, value, callback) => {
      if (this.orderForm.shippingDetail.city == "") {
        callback(new Error("城市必选"));
      } else {
        callback();
      }
    };
    var checkFormBodyTextcontractName = (rule, value, callback) => {
      if (!this.fbaChecked) {
        if (this.orderForm.shippingDetail.contractName == "")
          callback(new Error("联系人必填"));
        callback();
      } else {
        callback();
      }
    };
    var checkFormBodyText = (rule, value, callback) => {
      if (!this.fbaChecked) {
        if (this.orderForm.shippingDetail.country == "")
          callback(new Error("国家必选"));
        callback();
      } else {
        callback();
      }
    };
    var checkFormBodyTextcountry = (rule, value, callback) => {
      if (this.orderForm.shippingDetail.country == "") {
        callback(new Error("国家必选"));
      } else {
        callback();
      }
    };
    var checkFormBodyTextphone = (rule, value, callback) => {
      if (!this.fbaChecked) {
        if (this.orderForm.shippingDetail.phone == "")
          callback(new Error("联系电话"));
        callback();
      } else {
        callback();
      }
    };
    var checkFormBodyTextprovince = (rule, value, callback) => {
      if (this.orderForm.shippingDetail.province == "") {
        callback(new Error("省份&州必选"));
      } else {
        callback();
      }
    };

    var checkFormBottomTotalCarton = (rule, value, callback) => {
      if (!value || !parseInt(value) || isNaN(value) || parseInt(value) <= 0) {
        callback(new Error("货物箱数必须为大于0的整数"));
      } else {
        callback();
      }
    };

    return {
      uploadCartonDetail: false,
      conditions: {
        sku: ""
      },
      imgFile: [],
      //高德地图
      isInit: true,
      isOpen: false,
      markers: [
        {
          id: "",
          title: "【东莞仓】",
          position: [113.753228, 22.9833],
          address: "广东省东莞市南城街道东骏豪苑(东骏路)",
          name: "blry",
          phone: "13713262222"
        },
        {
          title: "【龙岗仓】",
          position: [114.234824, 22.723301],
          address: "广东省深圳市龙岗区龙城街道宏兴苑",
          name: "blry",
          phone: "13713263333"
        },
        {
          title: "【坂田仓】",
          position: [114.07314, 22.62579],
          address: "广东省深圳市龙岗区坂田第三工业区二栋一楼",
          name: "blry",
          phone: "13713261111"
        }
      ],
      mapObj: {},
      userCarry: [
        {
          title: "",
          address: "",
          name: "",
          phone: "",
          distance: ""
        }
      ],
      mapAddressFormVisible: false,
      fbaChecked: true,
      formData: {
        usMeasure: false
      },

      form: {
        test: "",
        radio: "1"
      },
      orderForm: {
        orgOwner: "",
        orgOp: "",
        warehoustCode: "",
        productId: "",
        remark: "",
        customsId: "",
        customerRefnumber: { customerOrderNumber: "", fbaNumber: "" },
        deliveryDetail: {
          deliveryType: "PICK_UP_FROM_CUSTOMER",
          warehouseCode: "",
          appointmentAt: formatDate(new Date()),
          expressCompany: "",
          expressNumber: "",
          contractName: "",
          phone: "",
          country: "",
          province: "",
          city: "",
          addressFirst: ""
        },
        shippingDetail: {
          contractName: "",
          phone: "",
          country: "",
          countryId: "",
          province: "",
          city: "",
          zipcode: "",
          addressFirst: "",
          addressSecond: "",
          companyName: ""
        },
        packingList: {
          goodsType: "",
          totalCarton: "",
          cartonDetails: []
        },
        generalTrade: false,
        purchaseInsurance: false,
        amazonReferenceId: ""
      },
      shippingDetail: {
        countryId: "",
        provinceId: "",
        cityId: ""
      },
      deliveryDetail: {
        provinceId: ""
      },
      productData: [],
      tmpProduct: {
        id: "",
        currency: "",
        sku: "",
        weight: "",
        zhName: "",
        enName: "",
        code: "",
        money: "",
        img: ""
      },
      orderFormRule: {
        appointmentAt: [
          {
            validator: checkFormHeadDate,
            trigger: "change"
          }
        ],
        expressCompany: [
          {
            required: true,
            validator: checkFormHeadText,
            trigger: "blur"
          }
        ],
        expressNumber: [
          {
            required: true,
            validator: checkFormHeadText,
            trigger: "blur"
          }
        ],
        customerOrderNumber: [
          {
            required: true,
            message: "请填写快递单号",
            trigger: "blur"
          }
        ]
      },
      orderFormRule3: {
        goodsType: [
          {
            required: true,
            message: "请选择货物类型",
            trigger: "change"
          }
        ],
        totalCarton: [
          {
            validator: checkFormBottomTotalCarton,
            trigger: "blur"
          }
        ]
      },
      orderFormRule2: {
        customerOrderNumber: [
          {
            validator: checkFormBodyTextorderNumber,
            trigger: "change"
          }
        ],
        shippingPhone: [
          {
            required: true,
            validator: checkFormBodyTextphone,
            trigger: "change"
          }
        ],
        shippingProvince: [
          {
            required: true,
            validator: checkFormBodyTextprovince,
            trigger: "change"
          }
        ],
        shippingProvince2: [
          {
            required: true,
            validator: checkFormBodyTextprovince,
            trigger: "blur"
          }
        ],
        zipcode: [{ required: true, message: "请输入邮编", trigger: "blur" }],
        shippingContractName: [
          {
            required: true,
            validator: checkFormBodyTextcontractName,
            trigger: "change"
          }
        ],
        shippingCountry: [
          {
            required: true,
            validator: checkFormBodyTextcountry,
            trigger: "change"
          }
        ],
        shippingCity: [
          {
            required: true,
            validator: checkFormBodyTextcity,
            trigger: "change"
          }
        ],
        shippingAddressFirst: [
          {
            required: true,
            validator: checkFormBodyTextaddressFirst,
            trigger: "change"
          }
        ]
      },
      rulesTmpProduct: {
        sku: [
          {
            required: true,
            message: "请输入SKU",
            trigger: "blur"
          }
        ],
        zhName: [
          {
            required: true,
            message: "请输入中文品名",
            trigger: "blur"
          }
        ],
        code: [
          {
            required: true,
            message: "请输入海关编码",
            trigger: "blur"
          }
        ],
        enName: [
          {
            required: true,
            message: "请输入英文品名",
            trigger: "blur"
          }
        ],
        weight: [
          {
            required: true,
            message: "请输入重量",
            trigger: "blur"
          },
          {
            // type: "number",
            message: "重量必须是数字",
            trigger: "blur"
          }
        ],
        money: [
          {
            required: true,
            message: "请输入申报金额",
            trigger: "blur"
          },
          {
            // type: "number",
            message: "申报金额必须是数字",
            trigger: "blur"
          }
        ]
      },
      productHistoryList: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      productForm: {
        test: "",
        guigeRadio: "1",
        select: "shanghai",
        boxNumber: 0
      },
      //上门取件
      tableAddressData: [
        {
          address: "广东省深圳市南山区学府路南山智园B11栋14楼(Daniel)",
          name: "blry",
          phone: "18682152960"
        }
      ],
      addressForm: {
        address: "广东省深圳市南山区学府路南山智园B11栋14楼(Daniel)",
        name: "blry",
        phone: "18682152960"
      },
      addressFormVisible: false,
      dialogFormVisible: false,
      formLabelWidth: "120px",
      options: [
        {
          value: "CNY",
          label: "人民币"
        },
        {
          value: "HKD",
          label: "港币"
        },
        {
          value: "GBP",
          label: "英镑"
        },
        {
          value: "USD",
          label: "美元"
        },
        {
          value: "JPY",
          label: "日元"
        },
        {
          value: "EUR",
          label: "欧元"
        }
      ],
      value: "",
      guige: {
        long: "",
        width: "",
        height: "",
        weight: ""
      },
      guigeArr: [],
      addGuige: {
        number: "",
        long: "",
        width: "",
        height: "",
        weight: ""
      },
      addGuigeErro: "",
      addGuigeShow: false,
      listTable: false, //添加sku
      addSPinfo: false,
      lishiTable: false,
      spList: [], //sku列表
      spListSelection: [],
      spListIndex: "",
      spListIndexData: "",
      standardSkus: [], //每箱同sku
      lishiList: [
        {
          sku: "HF001",
          zhName: "黑色签字笔",
          enName: "pen",
          enName: "pen",
          code: "547896542",
          money: "￥5.00",
          img:
            "https://y.gtimg.cn/music/photo_new/T001R300x300M000002J4UUk29y8BY.jpg?max_age=2592000"
        }
      ],
      dialogImageUrl: "", //上传图片
      dialogVisible: false,
      initialDataFbaAddress: [],
      initialDataCountry: [],
      initialDataProvince: [],
      initialDataCity: [],
      initialDataProvinceChina: [],
      initialDataCityChina: [],
      initialDataWarehouseAddress: [],
      currentWarehouseAddress: "",
      addImg: "",
      cartonDialogTitle: "添加货箱信息",
      addGuigeIndex: "",
      rulesAddGuige: {
        number: [
          {
            required: true,
            validator: checkInteger,
            trigger: "blur"
          }
        ],
        long: [
          {
            required: true,
            validator: checkNumber,
            trigger: "blur"
          }
        ],
        width: [
          {
            required: true,
            validator: checkNumber,
            trigger: "blur"
          }
        ],
        height: [
          {
            required: true,
            validator: checkNumber,
            trigger: "blur"
          }
        ],
        weight: [
          {
            required: true,
            validator: checkNumber,
            trigger: "blur"
          }
        ]
      },
      appointmentAtOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            }
          },
          {
            text: "明天",
            onClick(picker) {
              let _tomorrow = new Date(
                new Date(
                  new Date().getTime() + 3600 * 1000 * 24
                ).toLocaleDateString()
              );
              picker.$emit("pick", _tomorrow);
            }
          },
          {
            text: "后天",
            onClick(picker) {
              let _afterTomorrow = new Date(
                new Date(
                  new Date().getTime() + 3600 * 1000 * 24 * 2
                ).toLocaleDateString()
              );
              picker.$emit("pick", _afterTomorrow);
            }
          }
        ],
        disabledDate(time) {
          return time < new Date(new Date().toLocaleDateString()).getTime();
        }
      },
      editProductTitle: "新增商品信息",
      nextAddProductButton: true,
      clone(obj) {
        if (!obj || typeof obj != "object") return obj;
        let _newObj = new Object();
        for (let key in obj) {
          _newObj[key] = clone(obj[key]);
        }
        return _newObj;
      },
      flag: false,
      goodsTypeList: [],
      warehouseData: [],
      warehouseId: "",
      warehouse: [],
      timeDialogVisible: false,
      currentTime: {
        year: "",
        month: "",
        day: "",
        hour: ""
      },
      fileList: [],
      templateFile: ""
    };
  },
  created() {
    // init data
    var _this = this;
    _this.queryCountrys();
    _this.queryProvinceOfChina();
    _this.loadProducts();
    _this.loadGoodsType();
    setTimeout(() => {
      _this.queryWarehouseData();
      _this.queryFbaAddress();
      _this.loadCustomerAddress();
    }, 800);
  },
  computed: {
    computedDate() {
      let now = new Date().getTime();
      // console.log(now);
      for (let i = 0; i < 7; i++) {
        // console.log((now += 24 * 3600 * 1000));
      }
    },
    //总体积
    allTiji: function() {
      if (this.productForm.guigeRadio == "1") {
        if (
          this.orderForm.packingList.totalCarton &&
          this.guige.long &&
          this.guige.width &&
          this.guige.height
        ) {
          return (
            (parseInt(this.orderForm.packingList.totalCarton) *
              parseInt(this.guige.long) *
              parseInt(this.guige.width) *
              parseInt(this.guige.height)) /
            1000000
          ).toFixed(4);
        } else {
          return 0;
        }
      } else {
        if (this.guigeArr.length > 0) {
          let num = 0;
          this.guigeArr.forEach((d, i) => {
            if (d.number && d.long && d.width && d.height) {
              num +=
                (parseInt(d.number) *
                  parseInt(d.long) *
                  parseInt(d.width) *
                  parseInt(d.height)) /
                1000000;
            }
          });
          return num.toFixed(4);
        } else {
          return 0;
        }
      }
    },
    //总重量
    allWeight: function() {
      if (this.productForm.guigeRadio == "1") {
        let weight =
          this.guige.weight && this.orderForm.packingList.totalCarton
            ? parseInt(this.orderForm.packingList.totalCarton) *
              parseFloat(this.guige.weight)
            : 0;
        if (this.orderForm.packingList.totalCarton && this.guige.weight) {
          return weight.toFixed(4);
        } else {
          return 0;
        }
      } else {
        if (this.guigeArr.length == 0) return 0;
        let num = 0;
        this.guigeArr.forEach((d, i) => {
          if (d.number && d.weight) {
            num += parseInt(d.number) * parseInt(d.weight);
          }
        });
        return num.toFixed(4);
      }
    }
  },
  watch: {
    //监听规格是否相同
    "productForm.guigeRadio": function() {
      this.guige = {
        long: "",
        width: "",
        height: "",
        weight: ""
      };
      this.guigeArr = [];
    }
  },
  methods: {
    setupPickupTime() {
      this.timeDialogVisible = true;
    },
    calPickupTime() {
      let now = new Date(),
        year = now.getFullYear(),
        month = now.getMonth() + 1,
        day = now.getDate(),
        hour = now.getHours();
      hour < 10 ? "0" + hour : hour;
      this.currentTime = {
        year: year,
        month: month,
        day: day,
        hour: hour
      };
    },
    back() {
      this.$router.go(-1);
    },
    //高德地图保存地址
    handleSmenSaveMap() {
      this.mapAddressFormVisible = false;
      this.userCarry[0].title = this.mapObj.title;
      this.userCarry[0].address = this.mapObj.address;
      this.userCarry[0].name = this.mapObj.name;
      this.userCarry[0].phone = this.mapObj.phone;
      this.userCarry[0].distance = this.mapObj.distance;
    },
    //点击仓库
    getMapForm(val) {
      this.mapObj = val;
      this.currentWarehouseAddress = val;
      if (
        this.orderForm.deliveryDetail.deliveryType == "DELIVERY" ||
        this.orderForm.deliveryDetail.deliveryType == "DELIVERY_BY_EXPRESS"
      ) {
        this.orderForm.deliveryDetail.warehouseCode = val.id;
        this.orderForm.deliveryDetail.contractName = val.receiptPersonName;
        this.orderForm.deliveryDetail.phone = val.receiptPersonPhone;
        this.orderForm.deliveryDetail.country =
          val.warehouseAddress.countryCode;
        this.orderForm.deliveryDetail.province = val.warehouseAddress.province;
        this.orderForm.deliveryDetail.city = val.warehouseAddress.city;
        this.orderForm.deliveryDetail.addressFirst =
          val.warehouseAddress.address;
      } else {
        this.orderForm.deliveryDetail.warehouseCode = val.id;
      }

      if (this.isInit) {
        this.userCarry[0].title = val.name;
        this.userCarry[0].address = val.warehouseAddress.address;
        this.userCarry[0].name = val.receiptPersonName;
        this.userCarry[0].phone = val.phone;
        this.userCarry[0].distance = val.distance;
        this.isInit = false;
      }
    },
    //获取经纬度：
    getGeocoder(val) {},
    //地图编辑地址
    handleMapEdit(index, row) {
      var self = this;
      this.mapAddressFormVisible = true;
      if (!this.isOpen) {
        clearTimeout(timer);
        let timer = setTimeout(function() {
          self.$refs.spAmap.appendChild(document.getElementById("sp-amap"));
          self.isOpen = true;
        }, 50);
      }
    },
    //编辑地址
    handleEdit(index, row) {
      this.addressFormVisible = true;
    },
    //------------------箱子信息-----------------------------------------//
    closeUploadFile() {
      this.templateFile = "";
      this.$refs.uploadExcel.clearFiles();
      this.dialogUpLoadVisible = false;
    },
    fileChange(file, fileList) {
      this.templateFile = file.raw;
    },
    exceedFile(file, fileList) {
      fileList[0].name = file[0].name;
      fileList[0].raw = file[0];
      fileList[0].size = file[0].size;
      this.templateFile = file[0];
    },
    //保存
    handleSaveguige() {
      let _this = this;
      let _valid = false;
      _this.$refs["addGuige"].validate(valid => {
        if (!valid) {
          _valid = false;
        } else {
          _valid = true;
        }
      });
      if (!_valid) {
        return false;
      }
      for (let key in _this.addGuige) {
        let item = _this.addGuige[key];
        if (
          !_this.formData.usMeasure &&
          (!item || isNaN(item) || parseFloat(item) <= 0)
        ) {
          //SPFunc.spAlert(_this, "必须大于0");
          //return;
        }
      }
      this.addGuigeShow = false;
      if (this.addGuigeIndex !== undefined && !isNaN(this.addGuigeIndex)) {
        this.guigeArr.splice(this.addGuigeIndex, 1, this.addGuige);
      } else {
        this.guigeArr.push(this.addGuige);
      }
      this.addGuigeIndex = undefined;
      this.addGuige = {
        number: "",
        long: "",
        width: "",
        height: "",
        weight: ""
      };
      this.resetForm("addGuige");
    },
    resetForm(formName) {
      this.$refs[formName].clearValidate();
    },
    //新增/编辑箱子信息
    handleEditGuige(item, index) {
      this.addGuigeShow = true;
      this.addGuigeIndex = index;
      this.addGuige = {
        number: "",
        long: "",
        width: "",
        height: "",
        weight: ""
      };
      this.cartonDialogTitle = "添加货箱信息";
      if (index || index >= 0) {
        this.cartonDialogTitle = "编辑货箱信息";
        this.addGuige = item;
      }
    },
    measureEditSkus(index) {
      //箱子规格不同编辑sku
      let _this = this;
      if (_this.guigeArr[index]) {
        if (_this.guigeArr[index].skus) {
          _this.spList = JSON.parse(JSON.stringify(_this.guigeArr[index].skus));
        } else {
          _this.guigeArr[index].skus = new Array();
          _this.spList = JSON.parse(JSON.stringify(_this.guigeArr[index].skus));
        }
        _this.spListIndex = index;
        _this.spListIndexData = _this.guigeArr[index];
        _this.listTable = true;
      }
    },
    //删除
    handleDeleteGuige(item, index) {
      this.guigeArr.splice(index, 1);
    },
    //-------------------商品信息------------------
    //新增/编辑商品信息
    spHandleEdit(index, row) {
      let _this = this;
      _this.addSPinfo = true;
      _this.imgFile = [];
      if (row) {
        _this.editProductTitle = "编辑商品信息";
        _this.nextAddProductButton = false;
        _this.tmpProduct = row;
        let file = new Object();
        file.url = row.img;
        _this.imgFile.push(file);
      } else {
        _this.editProductTitle = "新增商品信息";
        _this.nextAddProductButton = true;
        // _this.tmpProduct = new Object();
        _this.tmpProduct.id = "";
        // _this.tmpProduct.currency = "";
        _this.tmpProduct.sku = "";
        _this.tmpProduct.weight = "";
        _this.tmpProduct.zhName = "";
        _this.tmpProduct.enName = "";
        _this.tmpProduct.code = "";
        _this.tmpProduct.money = "";
        _this.tmpProduct.img = "";
        _this.addImg = "";
      }
    },
    //删除商品信息
    spHandleDelete(index, row) {
      this.spList.splice(index, 1);
    },
    //历史商品列表选中
    handleSelectionChange(val) {
      this.spListSelection = val;
    },
    openHistoryListDialog() {
      this.lishiTable = true
      if(this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection()
      }
    },
    //历史商品列表保存
    handleSaveSp() {
      this.lishiTable = false;
      // this.spList = [];
      // if(this.spList.length == 0) {
      //   this.spListSelection.forEach((d, i) => {
      //     let _d = this.clone(d);
      //     this.spList.push(_d);
      //   });
      // } else{
        this.spListSelection.forEach(item => {
          let selectedItem = this.spList.find(i => {
            return i.sku == item.sku
          })
          if(selectedItem) {
            return
          } else{
            this.spList.push(item)
          }
        })
      // }
    },

    currentPage(page) {
      this.productHistoryList.page = page;
      let sku = this.conditions.sku;
      this.loadProducts(sku);
    },
    skuEditClose() {
      let _this = this;
      let _removeIndex = new Array();
      if (_this.spList) {
        for (let i = 0; i < _this.spList.length; i++) {
          if (!_this.spList[i].number || _this.spList[i].number <= 0) {
            _this.spList.splice(i, 1);
            i--;
          }
        }
      }
    },
    //sku数据保存
    skuSaveSp() {
      let _this = this;
      let _isFailed = false;
      _this.spList.forEach((data, index) => {
        if (!data.number || data.number <= 0 || isNaN(data.number)) {
          _isFailed = true;
        }
      });
      if (_isFailed) {
        _this.$message.error("SKU数量必须为大于0的数字");
      } else {
        _this.listTable = false;
      }
      if (_this.spListIndexData && _this.spListIndexData != "") {
        _this.spListIndexData.skus = JSON.parse(JSON.stringify(_this.spList));
        _this.$set(_this.guigeArr, _this.spListIndex, _this.spListIndexData);
      }
      _this.standardSkus = _this.spList;
    },
    //历史搜索
    skuHistorySearch() {
      this.productHistoryList.page = 1;
      this.loadProducts(this.conditions.sku);
    },
    loadProducts(sku) {
      //初始化sku
      let _this = this;
      _this.$request1
        .get(
          '/center/productList',
          {
            params: {
              orgOwner: _this.$route.query.customer,
              page: _this.productHistoryList.page,
              pageSize: _this.productHistoryList.pageSize,
              sku: sku
            },
            withCredentials: true,
            headers: {
              "content-type": "application/json"
            }
          }
        )
        .then(res => {
          if (res.data && res.data.products.length > 0) {
            _this.productData = res.data.products;
            _this.productHistoryList.total = +res.data.total;
          } else {
            _this.productData = [];
            _this.productHistoryList.total = 0;
            // _this.$message.error(res.data.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    imgChange(file, fileList) {
      this.addImg = file.raw;
    },
    //新增/编辑商品信息保存
    handleAddSp(index, row) {
      this.addProduct(true);
    },
    handleAddSpContinue() {
      this.addProduct(false);
    },
    getFormData(form, pic) {
      let _this = this;
      var formData = new FormData();
      for (var key in form) {
        formData.append(key, form[key]);
      }
      formData.append("pic", pic);
      formData.append("orgOwner", _this.$route.query.customer);
      return formData;
    },
    addProduct(closeEdit) {
      let _this = this;
      let _valid = true;
      _this.$refs["tmpProduct"].validate(valid => {
        if (!valid) {
          _valid = false;
        }
      });
      if (!_valid) {
        return false;
      }
      let form = _this.tmpProduct;
      let formData = _this.getFormData(form, _this.addImg);

      _this.$request1
        .post(
          '/center/product/addProduct',
          formData,
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          if (res.status == 413) {
            _this.$notify.error({
              title: "创建失败,异常提示:",
              message:
                "文件超过规定大小，限制最大不超过10MB，请精简其中图片内容后重新上传。"
            });
          } else if (res.data.success) {
            if (res.data.data && res.data.data.length > 0) {
              //添加到历史数据并添加到列表
              if (!_this.tmpProduct || !_this.tmpProduct.id) {
                _this.spList.push(res.data.data[0]);
                _this.productData.push(res.data.data[0]);
                _this.productHistoryList.total += 1;
              }
              _this.spList.forEach((item, index) => {
                res.data.data.forEach((data, i) => {
                  if (item.sku == data.sku) {
                    _this.$set(item, "img", data.img);
                  }
                });
              });
              _this.productData.forEach((item, index) => {
                res.data.data.forEach((data, i) => {
                  if (item.sku == data.sku) {
                    _this.$set(item, "img", data.img);
                  }
                });
              });
            }
            if (closeEdit) {
              _this.addSPinfo = false;
            } else {
              // _this.tmpProduct = new Object();
              _this.tmpProduct.id = "";
              _this.tmpProduct.currency = "";
              _this.tmpProduct.sku = "";
              _this.tmpProduct.weight = "";
              _this.tmpProduct.zhName = "";
              _this.tmpProduct.enName = "";
              _this.tmpProduct.code = "";
              _this.tmpProduct.money = "";
              _this.tmpProduct.img = "";
              _this.addImg = "";
            }
            _this.$message.success("商品信息添加成功!");
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(function(error) {
          console.log(error);
          if (error.response.status === 413) {
            _this.$notify.error({
              title: "请求失败,异常提示:",
              message:
                "文件超过规定大小，限制最大不超过10MB，请精简其中图片内容后重新上传。"
            });
          } else {
            _this.$notify.error({
              title: "请求失败,异常提示:",
              message: error.response.statusText,
              duration: 0
            });
          }
        });
    },
    // 图片本地上传预览
    previewFiles() {
      var preview = document.querySelector(".file-content img");
      var file = document.querySelector("input[type=file]").files[0];
      var reader = new FileReader();

      reader.addEventListener(
        "load",
        function() {
          if (/\.(jpe?g|png|gif)$/i.test(file.name)) {
            preview.src = reader.result;
            preview.style.width = "50px";
            preview.style.height = "50px";
            preview.style.display = "block";
          } else {
            SPFunc.spAlert(
              _this,
              "请上传合法的图片类型，如:jpg, jpeg, png, gif"
            );
          }
        },
        false
      );

      if (file) {
        reader.readAsDataURL(file);
      }
    },
    editCartonSkus() {
      let _this = this;
      _this.listTable = true;
      _this.spList = _this.standardSkus;
      _this.spListIndexData = "";
      _this.spListIndex = -1;
    },
    saveAddressOfDeliver() {
      let _this = this;
      _this.addressFormVisible = false;
      _this.initialDataProvinceChina.forEach((d, i) => {
        if (_this.deliveryDetail.provinceId == d.id) {
          _this.orderForm.deliveryDetail.province = d.nameCn;
        }
      });
    },
    changedeliveryType(v) {
      let _this = this;
      if (v == "DELIVERY" || v == "DELIVERY_BY_EXPRESS") {
        if (_this.currentWarehouseAddress == "") {
          return;
        }
        //送货到仓库
        _this.orderForm.warehoustCode = _this.currentWarehouseAddress.id;
        _this.orderForm.deliveryDetail.warehouseCode =
          _this.currentWarehouseAddress.id;
        _this.orderForm.deliveryDetail.contractName =
          _this.currentWarehouseAddress.receiptPersonName;
        _this.orderForm.deliveryDetail.phone =
          _this.currentWarehouseAddress.receiptPersonPhone;
        _this.orderForm.deliveryDetail.country =
          _this.currentWarehouseAddress.warehouseAddress.countryCode;
        _this.orderForm.deliveryDetail.province =
          _this.currentWarehouseAddress.warehouseAddress.province;
        _this.orderForm.deliveryDetail.city =
          _this.currentWarehouseAddress.warehouseAddress.city;
        _this.orderForm.deliveryDetail.addressFirst =
          _this.currentWarehouseAddress.warehouseAddress.address;
      } else if (v == "PICK_UP_FROM_CUSTOMER") {
        //上门取件
        _this.orderForm.deliveryDetail.contractName = "";
        _this.orderForm.deliveryDetail.phone = "";
        _this.orderForm.deliveryDetail.country = "";
        _this.deliveryDetail.provinceId = "";
        _this.orderForm.deliveryDetail.province = "";
        _this.orderForm.deliveryDetail.city = "";
        _this.orderForm.deliveryDetail.addressFirst = "";
      }
    },
    queryCountrys() {
      var _this = this;
      _this.$request1
        .get(
          '/countryfilter',
          {
            params: {
              channelId: _this.$route.query.product
            },
            withCredentials: true,
            headers: {
              "content-type": "application/json"
            }
          }
        )
        .then(function(response) {
          if (response.status == 200 && response.data.success) {
            _this.initialDataCountry = response.data.data;
          } else {
            _this.$message.error("加载初始化数据失败");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    loadGoodsType() {
      let _this = this;
      _this.$request1
        .get(
          '/order/goods-type-list',
          {
            withCredentials: true,
            headers: {
              "content-type": "application/json"
            }
          }
        )
        .then(res => {
          if (res.status == 200) {
            _this.goodsTypeList = res.data;
          } else {
            _this.$message.error("加载初始化数据失败loadGoodsType");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    createFilter(queryString) {
      return restaurant => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    querySearchCountry(queryString, cb) {
      var restaurants = this.initialDataCountry;
      restaurants.forEach((d, i) => {
        d.value = d.nameEn;
      });
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      cb(results);
    },
    queryProvince(countryId) {
      var _this = this;
      _this.initialDataCountry.forEach((d, i) => {
        if (d.id == _this.shippingDetail.countryId) {
          _this.orderForm.shippingDetail.country = d.nameEn;
        }
      });

      _this.$request1
        .get(
          '/province/' + countryId + '',
          {
            withCredentials: true,
            headers: {
              "content-type": "application/json"
            }
          }
        )
        .then(function(response) {
          if (response.status == 200 && response.data.success) {
            _this.initialDataProvince = response.data.data;
          } else {
            _this.$message.error("加载初始化数据失败");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    queryProvinceOfChina() {
      var _this = this;
      _this.$request1
        .get(
          '/province/' + 1 + '',
          {
            withCredentials: true,
            headers: {
              "content-type": "application/json"
            }
          }
        )
        .then(function(response) {
          if (response.status == 200 && response.data.success) {
            _this.initialDataProvinceChina = response.data.data;
          } else {
            _this.$message.error("加载初始化数据失败");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    queryCity(provinceId) {
      var _this = this;
      _this.initialDataProvince.forEach((d, i) => {
        if (d.id == _this.shippingDetail.provinceId) {
          _this.orderForm.shippingDetail.province = d.nameEn;
        }
      });
      _this.$request1
        .get(
          '/city/' + provinceId + '',
          {
            withCredentials: true,
            headers: {
              "content-type": "application/json"
            }
          }
        )
        .then(function(response) {
          if (response.status == 200 && response.data.success) {
            _this.initialDataCity = response.data.data;
          } else {
            _this.$message.error("加载初始化数据失败");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    selectCity() {
      var _this = this;
      _this.initialDataCity.forEach((d, i) => {
        if (d.id == _this.shippingDetail.cityId) {
          _this.orderForm.shippingDetail.city = d.nameEn;
        }
      });
    },
    queryCityOfChina(provinceId) {
      var _this = this;
      _this.orderForm.deliveryDetail.city = "";
      _this.$request1
        .get(
          '/city/' + provinceId + '',
          {
            withCredentials: true,
            headers: {
              "content-type": "application/json"
            }
          }
        )
        .then(function(response) {
          if (response.status == 200 && response.data.success) {
            _this.initialDataCityChina = response.data.data;
          } else {
            _this.$message.error("加载初始化数据失败");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    buildingOrderForm() {
      //校验表单格式
      let _this = this;
      let _orgOwner = _this.$route.query.customer;
      let _productId = _this.$route.query.product;

      if (!_orgOwner || _orgOwner == "" || !_productId || _productId == "") {
        _this.$message.error(
          "未选择客户和产品，请回退到订单页面重新选择新建订单!"
        );
        return false;
      }
      _this.orderForm.orgOp = "";
      _this.orderForm.productId = _productId;
      _this.orderForm.orgOwner = _orgOwner;
      _this.orderForm.warehoustCode = _this.currentWarehouseAddress.id;
      if (_this.fbaChecked) {
        if (!_this.orderForm.shippingDetail.contractName) {
          _this.orderForm.shippingDetail.contractName = "amazon";
        }
        if (!_this.orderForm.shippingDetail.phone) {
          _this.orderForm.shippingDetail.phone = "9999999999";
        }
      }
      let _validHead = true;
      _this.$refs["orderForm1"].validate(valid => {
        if (!valid) {
          _validHead = false;
        }
      });

      let _validBody = true;
      _this.$refs["orderForm2"].validate(valid => {
        if (!valid) {
          _validBody = false;
        }
      });
      let _validBottom = true;
      _this.$refs["orderForm3"].validate(valid => {
        if (!valid) {
          _validBottom = false;
        }
      });

      let _validExtraFields = true;
      if (_this.$refs["extraFieldsForm"] != null) {
        _this.$refs["extraFieldsForm"].validate(valid => {
          if (!valid) {
            _validExtraFields = false;
          }
        });
      }

      if (!_validHead || !_validBody || !_validBottom || !_validExtraFields) {
        return false;
      }

      let _realTotalCount = 0;
      if (_this.productForm.guigeRadio == 2 && !_this.uploadCartonDetail) {
        if (!_this.guigeArr || _this.guigeArr.length <= 0) {
          _this.$message.error("箱子信息和sku信息必填");
          return false;
        } else {
          let _checkout = true;
          _this.guigeArr.forEach((d, i) => {
            if (!d.skus || d.skus.length <= 0) {
              _checkout = false;
            }
            if (!d.number || d.number <= 0 || isNaN(d.number)) {
              _checkout = false;
            } else {
              _realTotalCount += parseInt(d.number);
            }
            if (!_this.formData.usMeasure) {
              if (!d.long || d.long <= 0) {
                _checkout = false;
              }
              if (!d.width || d.width <= 0) {
                _checkout = false;
              }
              if (!d.height || d.height <= 0) {
                _checkout = false;
              }
              if (!d.weight || d.weight <= 0) {
                _checkout = false;
              }
            }
          });
          if (!_checkout) {
            _this.$message.error("箱子信息和sku信息必填,且箱明细数据必须大于0");
            return false;
          }
        }
      }

      if (!_this.uploadCartonDetail) {
        let _totalCarton = parseInt(_this.orderForm.packingList.totalCarton);
        var cartonDetails = new Array();
        if (_this.productForm.guigeRadio == 1) {
          //箱子规格相同
          if (!_this.formData.usMeasure) {
            for (let key in _this.guige) {
              if (!_this.guige[key] || parseFloat(_this.guige[key]) <= 0) {
                _this.$message.error("箱子件毛体和数量必填");
                return;
              }
            }
          }
          if (!_this.standardSkus || _this.standardSkus.length <= 0) {
            _this.$message.error("SKU信息必填");
            return;
          }
          var item = new Array();
          _this.standardSkus.forEach((d, i) => {
            var obj = new Object();
            obj.sku = d.sku;
            obj.qty = d.number;
            item.push(obj);
          });

          for (let i = 0; i < _totalCarton; i++) {
            var cartonDetail = new Object();
            if (!_this.formData.usMeasure) {
              cartonDetail.length = parseFloat(_this.guige.long);
              cartonDetail.width = parseFloat(_this.guige.width);
              cartonDetail.height = parseFloat(_this.guige.height);
              cartonDetail.weight = parseFloat(_this.guige.weight);
            } else {
              cartonDetail.length = 0;
              cartonDetail.width = 0;
              cartonDetail.height = 0;
              cartonDetail.weight = 0;
            }
            cartonDetail.items = item;
            cartonDetails.push(cartonDetail);
          }
        } else {
          //箱子规格不同_totalCarton
          if (_realTotalCount != _totalCarton) {
            _this.$message.error(
              "箱规格不相同时，界面上填的货物箱数必须和明细里填的货物箱数的总数一致。"
            );
            return false;
          }
          _this.guigeArr.forEach((d, i) => {
            let _number = parseInt(d.number);

            var item = new Array();
            d.skus.forEach((d, i) => {
              var obj = new Object();
              obj.sku = d.sku;
              obj.qty = d.number;
              item.push(obj);
            });

            for (let i = 0; i < _number; i++) {
              var cartonDetail = new Object();
              if (!_this.formData.usMeasure) {
                cartonDetail.length = parseFloat(d.long);
                cartonDetail.width = parseFloat(d.width);
                cartonDetail.height = parseFloat(d.height);
                cartonDetail.weight = parseFloat(d.weight);
              } else {
                cartonDetail.length = 0;
                cartonDetail.width = 0;
                cartonDetail.height = 0;
                cartonDetail.weight = 0;
              }
              cartonDetail.items = item;
              cartonDetails.push(cartonDetail);
            }
          });
        }
        _this.orderForm.packingList.cartonDetails = cartonDetails;
      }
      return true;
    },
    createOrderSubmit() {
      //提交订单
      var _this = this;
      if (!_this.buildingOrderForm()) {
        return;
      }

      var formData = new FormData();
      formData.append("uploadCartonDetail", _this.uploadCartonDetail);
      for (var key in _this.orderForm) {
        if (
          key == "customerRefnumber" ||
          key == "deliveryDetail" ||
          key == "packingList" ||
          key == "shippingDetail"
        ) {
          formData.append(key, JSON.stringify(_this.orderForm[key]));
        } else {
          formData.append(key, _this.orderForm[key]);
        }
      }

      if (_this.uploadCartonDetail) {
        if (!_this.templateFile || _this.templateFile.length == 0) {
          this.$message.error("请选择文件。");
          return false;
        } else {
          formData.append("template", _this.templateFile);
        }
      }

      _this.$request1
        .post(
          '/order/create',
          formData,
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          if (res.data.result.success) {
            _this.$alert(res.data.orderId, "创建订单成功,订单号为:", {
              confirmButtonText: "确定",
              callback: action => {
                _this.$router.push("/order");
              }
            });
          } else {
            _this.$alert(res.data.result.message, "订单创建失败,异常提示", {
              confirmButtonText: "确定",
              callback: action => {}
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    queryWarehouseData() {
      let orgOwner = this.$route.query.customer;
      this.$request1({
        method: 'GET',
        url: '/warehouse/load',
        params: {
          orgOwner: orgOwner
        },
        xhrFields: {
          withCredentials: true
        }
      })
        .then(response => {
          this.warehouseData = response.data.data;
          this.flag = true;
          if (this.warehouseData.length == 1) {
            this.flag = false;
          }
          // this.getMapForm(this.warehouseData[0]);
          this.warehouse = [];
          response.data.data.forEach((d, i) => {
            d.title = d.name;
            d.address = d.warehouseAddress.address;
            d.position = d.warehouseAddress.position.split(",");

            let warehouse = { id: "", title: "" };
            warehouse.id = d.id;
            warehouse.title = d.name;
            this.warehouse.push(warehouse);
          });
          this.initialDataWarehouseAddress = response.data.data;
          let bantianWarehouse = this.warehouseData.find(item => {
            return item.name === '星邮坂田仓'
          })
          if(bantianWarehouse) {
            this.warehouseId = bantianWarehouse.id
            this.getMapForm(bantianWarehouse);
          } else{
            this.warehouseId = this.warehouseData[0].id;
            this.getMapForm(this.warehouseData[0]);
          }
          // this.currentWarehouseAddress = response.data.data[0];
        })
        .catch(error => {
          console.log(error);
        });
    },
    changeFbaWarehouseCode() {
      let _this = this;
      _this.initialDataFbaAddress.forEach((d, i) => {
        if (d.id == _this.shippingDetail.fbaWarehouseCode) {
          _this.orderForm.shippingDetail.country = d.country;
          _this.orderForm.shippingDetail.province = d.state;
          _this.orderForm.shippingDetail.city = d.city;
          _this.orderForm.shippingDetail.zipcode = d.postCode;
          _this.orderForm.shippingDetail.addressFirst = d.address;
          _this.orderForm.shippingDetail.fbaWarehouseCode = d.warehouseCode;
          _this.orderForm.shippingDetail.contractName = d.contactPerson;
          _this.orderForm.shippingDetail.phone = d.contactNumber;

          _this.getLocalLanguageCountry(d.country);
          setTimeout(() => {
            _this.getLocalLanguageProvince(d.state);
          }, 500);
        }
      });
    },
    getLocalLanguageCountry(country) {
      this.initialDataCountry.forEach((item, i) => {
        if (country == item.code) {
          this.queryProvince(item.id);
        }
      });
    },
    getLocalLanguageProvince(province) {
      this.initialDataProvince.forEach((item, i) => {
        if (province == item.code || province == item.nameEn) {
          this.queryCity(item.id);
        }
      });
    },
    queryFbaByAdressOrZipcode() {
      let _this = this;
      _this.$request1
        .get(
          '/warehouse-address/query-fba',
          {
            params: {
              adress: _this.orderForm.shippingDetail.addressFirst,
              zipcode: _this.orderForm.shippingDetail.zipcode
            },
            withCredentials: true,
            headers: {
              "content-type": "application/json"
            }
          }
        )
        .then(function(response) {
          if (response.status == 200 && response.data.success) {
            _this.orderForm.shippingDetail.fbaWarehouseCode = "";
            _this.initialDataFbaAddress = response.data.data;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    queryFbaAddress() {
      let _this = this;
      _this.$request1
        .get(
          '/warehouse-address/fba',
          {
            params: {
              channelId: _this.$route.query.product
            },
            withCredentials: true,
            headers: {
              "content-type": "application/json"
            }
          }
        )
        .then(function(response) {
          if (response.status == 200 && response.data.success) {
            _this.initialDataFbaAddress = response.data.data;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    loadCustomerAddress() {
      let _this = this;
      let _orgOwner = _this.$route.query.customer;
      if (!_orgOwner || _orgOwner.length == 0) {
      } else {
        _this.$request1
          .get(
            '/customer-address/' + _orgOwner + '',
            {
              withCredentials: true,
              headers: {
                "content-type": "application/json"
              }
            }
          )
          .then(res => {
            if (res.data.success && res.data.total > 0) {
              _this.orderForm.deliveryDetail.province = res.data.data.province;
              _this.orderForm.deliveryDetail.city = res.data.data.city;
              _this.orderForm.deliveryDetail.addressFirst =
                res.data.data.address;
              _this.orderForm.deliveryDetail.contractName = res.data.data.name;
              _this.orderForm.deliveryDetail.phone = res.data.data.phone;

              if (
                _this.initialDataProvinceChina &&
                _this.initialDataProvinceChina.length > 0
              ) {
                _this.initialDataProvinceChina.forEach((d, i) => {
                  if (d.nameCn == res.data.data.province) {
                    _this.orderForm.deliveryDetail.provinceId = d.id;
                    _this.deliveryDetail.provinceId = d.id;
                  }
                });
              }
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    changeShippingAddressType() {
      let _this = this;
      if (!_this.fbaChecked) {
        _this.orderForm.shippingDetail.contractName = "";
        _this.orderForm.shippingDetail.phone = "";
        _this.orderForm.shippingDetail.country = "";
        _this.orderForm.shippingDetail.province = "";
        _this.orderForm.shippingDetail.city = "";
        _this.orderForm.shippingDetail.zipcode = "";
        _this.orderForm.shippingDetail.addressFirst = "";
        _this.orderForm.shippingDetail.fbaWarehouseCode = "";
        _this.shippingDetail.provinceId = "";
        _this.shippingDetail.countryId = "";
        _this.shippingDetail.cityId = "";
      }
    },
    selectWarehouse() {
      this.warehouseData.forEach((item, index) => {
        if (item.id == this.warehouseId) {
          this.getMapForm(item);
          this.userCarry[0].title = item.name;
          this.userCarry[0].address = item.warehouseAddress.address;
          this.userCarry[0].name = item.receiptPersonName;
          this.userCarry[0].phone = item.phone;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
#sp-amap {
  position: fixed;
  top: 0;
  right: 100%;
  &.isOpen {
    position: relative;
    right: 0;
  }
}
.pickup-time {
  display: flex;
  a {
    margin-left: 15px;
    color: rgb(58, 142, 230);
    &:hover {
      text-decoration: underline;
    }
  }
}
.download-template {
  margin-right: 10px;
  color: #409eff;
  &:hover {
    text-decoration: underline;
  }
}
.shipper-detail__title {
  display: block;
  margin: 0 40px 15px 40px;
  padding: 5px 0;
  color: #606266;
  font-weight: 400;
  border-bottom: 1px dashed rgb(220, 223, 230);
  &.is-required::before {
    display: inline-block;
    margin-right: 4px;
    content: "*";
    color: #f56c6c;
  }
}

.pickup-content{
  display: flex !important;
  flex-wrap: wrap;
  align-items: center;
  .pickup-button {
    width: 300px;
  }
  .pickup-address {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-left: 15px;
    li {
      margin-right: 15px;
    }
  }
}

.inline-flex {
  display: flex;
  flex-wrap: wrap;
  > :first-child {
    margin-right: 15px;
  }
}

.input-group {
  width: 300px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  .size {
    width: 95px;
    &:not(:last-child) {
      margin-right: 6px;
    }
  }
}

.carton-table__content {
  margin-top: -10px;
  padding: 0 120px;
  &.single-sku {
    width: 870px;
    padding-right: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/order/neworder.vue